import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit {
  @Input() busy: boolean = true;
  @Input() busyText: string | null;

  constructor() {}

  ngOnInit(): void {}
}
